const DEBOUNCE_WAIT = 200;

export const debounce = ({ onChange, value, timer }) => {
  clearTimeout(timer);
  // eslint-disable-next-line no-param-reassign
  timer = setTimeout(() => {
    onChange(value);
  }, DEBOUNCE_WAIT);
};
